module.exports = __webpack_public_path__ + "assets/images/tooltip_photo.93b5ebf8a88f24620860d1c2b931a0af.png";